<template>

  <div class="vflex">

    <div class="vflex-row-0 pt-3">
      <ul class="nav nav-tabs">
        <li class="nav-item pl-3">
          <a
            class="nav-link"
            :class="{active: modelType === 'candidate'}"
            href="javascript:void(0)"
            @click="changeModelType('candidate')">{{ $t('Candidate') }}</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{active: modelType === 'job'}"
            href="javascript:void(0)"
            @click="changeModelType('job')">{{ $t('Job') }}</a>
        </li>
      </ul>
    </div>

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Tags') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <button
              type="button"
              class="btn btn-dark mr-2"
              v-if="selected.length >= 2"
              @click="mergeTags()">
              {{ $tc('merge_n_tags', selected.length, { count: selected.length }) }}
              </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New tag') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th-sort field="name" :value="sort" @input="setSort">{{ $t('Name') }}</th-sort>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(item, index) in tags"
                :key="index">
                <td width="10"><input type="checkbox" :value="item._id" v-model="selected"></td>
                <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal(item)">{{ item.name }}</a></td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <tag-form 
        v-if="modal_select"
        :initTag="modal_select" 
        @hideModal="hideModal()"
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()">
        </tag-form>

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import TagForm from './TagForm'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Tag',
  components: {
    TagForm,
    ThSort,
    InputKeyword,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name',
      selected: [],
      modelType: 'candidate'
    }
  },
  computed: {
    tags () {
      return this.$store.getters.getTags
    },
    paginate () {
      return this.$store.getters.getTagsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {
        type: this.modelType
      }
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        type: this.modelType,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectTags', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    /*
    mergeTags
    */
    mergeTags () {
      const mergeAction = () => {
        this.loading = true

        this.$store
        .dispatch('mergeTags', {
          type: this.modelType,
          tags: this.selected
        })
        .then((result) => {
          this.selected = []
          this.loadData(1)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: mergeAction,
        title: 'Deseja realmente unir esses registros?'
      })
    },
    changeModelType (type) {
      this.creating = true
      this.modelType = type
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Tag/Tag.vue